import "./PatientRightPanelDesktopView.scss";
import crossSvg from "../../common/icons/svg/cross.svg";
import { BED_DETAILS_MODULE, DEVICE_TYPES } from "../../common/constant/common-constants";
import PatientDetails from "../../components/PatientDetails/PatientDetails";
import AlarmHistoryContainer from "../AlarmHistoryContainer/AlarmHistoryContainer";
import ReportContainer from "../ReportContainer/ReportContainer";
import VitalDetailsContainer from "../VitalDetailsContainer/VitalDetailsContainer";
import PreUseHistory from "../PreUseHistoryContainer/PreUseHistory";
import PatientHistory from "../TrendContainer/NX5PatientHistory/PatientHistory";
import NewTrendContainer from "../TrendContainer/NewTrendContainer";
import V730iPatientHistory from "../TrendContainer/PatientHistory/V730iPatientHistory";
import { MODE } from "../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { VENTILATOR_ADDITIONAL_FEATURES } from "../../common/ENUMS/PARAMETER_ENUM";

import patientTypeAdult from "../../common/images/patient_type_adult.png";
import patientTypePediatric from "../../common/images/patient_type_pediatric.png";
import patientTypeNeonatal from "../../common/images/patient_type_neonatal.png";
import patientDetails from "../../common/images/patient_details.png";
import vitalGraphs from "../../common/images/vital_graphs.png";
import vitalTrends from "../../common/images/vital_trends.png";
import vitalReport from "../../common/images/vital_report.png";
import eventHistory from "../../common/images/event_history.png";
import preUseHistory from "../../common/images/pre_use_history.png";


const typeMap = {
    adult: patientTypeAdult,
    neonatal: patientTypeNeonatal,
    pediatric: patientTypePediatric,
};

function PatientRightPanelDesktopView(props) {
    const {
        bedId,
        activeSubHeader,
        handleSubHeaderClick,

        ventilatorConnected,
        user_enabled,
        ventilationStatus,
        activeVitalDevice,

        ventilatorPatientModeAlarmProfileData,
        ventilatorAdditionalFeaturesData,
        ventilatorModuleConnectionStatus,
    } = props;


    return (
        <div className="patient-right-panel-container">
            <div className="bed-info-container">

                <div className="bed-patient-Details">

                    <div className="bed-number">Bed: {props.bedDetails && props.bedDetails.bedName}</div>

                    {activeSubHeader === BED_DETAILS_MODULE.TRENDS_REPORTS && (
                        <div className="patient-history">
                            Patient History
                        </div>
                    )}

                    {activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS && activeVitalDevice === DEVICE_TYPES['VENTILATOR'] && (
                        <div className="patient-details">
                            <div className="patient-data">
                                {ventilatorPatientModeAlarmProfileData?.patientName
                                    ? ventilatorPatientModeAlarmProfileData.patientName.length > 7
                                        ? ventilatorPatientModeAlarmProfileData.patientName.slice(0, 7) + "..."
                                        : ventilatorPatientModeAlarmProfileData.patientName
                                    : "Name"}
                            </div>

                            <div className="pipe">|</div>
                            <div className="patient-data">
                                <div className="patient-data">
                                    {ventilatorPatientModeAlarmProfileData?.patientAge
                                        ? String(ventilatorPatientModeAlarmProfileData.patientAge).slice(0, 3)
                                        : "Age"}
                                </div>
                            </div>
                            <div className="pipe">|</div>
                            <div className="patient-data">
                                {(ventilatorPatientModeAlarmProfileData && ventilatorPatientModeAlarmProfileData.patientGender) || 'Gender'}
                            </div>
                        </div>
                    )}
                </div>
                <div className="ventilator-mode-details">

                    {activeVitalDevice === DEVICE_TYPES['VENTILATOR'] && (
                        <>
                            {activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS && (
                                <>
                                    {ventilatorConnected &&
                                        user_enabled &&
                                        (
                                            <img className="patient-type" src={typeMap[ventilatorPatientModeAlarmProfileData?.patientType]} alt="Patient Type" />

                                        )}

                                    <div className="ventilator-mode-details-right">

                                        {ventilatorConnected &&
                                            user_enabled &&
                                            (
                                                <div className="ventilator-mode-details-right-value">
                                                    {MODE[ventilatorPatientModeAlarmProfileData?.modeId]?.modeName ||
                                                        "-"}
                                                </div>
                                            )}

                                        <div className="ventilator-mode-details-right-pid">
                                            {ventilatorConnected &&
                                                user_enabled &&
                                                (
                                                    <>PID: {ventilatorPatientModeAlarmProfileData?.patientId || "-"}</>
                                                )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>

                <div className="ventilator-connected-modules">

                    {activeVitalDevice === DEVICE_TYPES['VENTILATOR'] && (
                        <>
                            {activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS && (
                                <>
                                    {ventilatorConnected && user_enabled && ventilationStatus && (
                                        <>
                                            <div className="connected-module-header">Connected / Active Modules</div>
                                            <div className="connected-modules-bottom">
                                                <div className="connected-module-value">
                                                    {ventilatorAdditionalFeaturesData?.find(
                                                        (f) => f.id === VENTILATOR_ADDITIONAL_FEATURES?.capnography
                                                    )?.on
                                                        ? "CO2"
                                                        : "-"}
                                                </div>
                                                <div className="pipe">
                                                    |
                                                </div>
                                                <div className="connected-module-value">
                                                    {ventilatorModuleConnectionStatus?.spo2 ? "SPO2" : "-"}
                                                </div>
                                                <div className="pipe">
                                                    |
                                                </div>
                                                <div className="connected-module-value">
                                                    {ventilatorAdditionalFeaturesData?.find(
                                                        (f) => f.id === VENTILATOR_ADDITIONAL_FEATURES?.pnumetic_nebulizer
                                                    )?.on
                                                        ? "Jet Neb"
                                                        : "-"}
                                                </div>
                                                <div className="pipe">
                                                    |
                                                </div>
                                                <div className="connected-module-value">
                                                    {ventilatorAdditionalFeaturesData?.find(
                                                        (f) => f.id === VENTILATOR_ADDITIONAL_FEATURES?.aerogen_nebulizer
                                                    )?.on
                                                        ? "Mesh Neb"
                                                        : "-"}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>

                            )}
                        </>
                    )}
                </div>
                <div className="ventilator-active-manuevers">
                    {activeVitalDevice === DEVICE_TYPES['VENTILATOR'] && (
                        <>
                            {activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS && (
                                <>
                                    {ventilatorConnected && user_enabled && ventilationStatus && activeVitalDevice !== DEVICE_TYPES['NOCCARC_PM_NX5'] && (
                                        <>
                                            <div className="active-manuevers-header">Active Manuevers</div>

                                            <div className="active-manuevers-value">
                                                {(() => {
                                                    const data = ventilatorAdditionalFeaturesData;

                                                    if (!data || data.length === 0) return "-";

                                                    // Priority order
                                                    const priority = [
                                                        { id: VENTILATOR_ADDITIONAL_FEATURES?.o2_boost, label: <>O<sub>2</sub> Boost</> },
                                                        { id: VENTILATOR_ADDITIONAL_FEATURES?.o2_suction, label: <>O<sub>2</sub> Suction</> },
                                                        { id: VENTILATOR_ADDITIONAL_FEATURES?.inspiratory_hold, label: "Inspiratory Hold" },
                                                        { id: VENTILATOR_ADDITIONAL_FEATURES?.expiratory_hold, label: "Expiratory Hold" },
                                                        { id: VENTILATOR_ADDITIONAL_FEATURES?.nif, label: "NIF" },
                                                        { id: VENTILATOR_ADDITIONAL_FEATURES?.p01, label: "P0.1" },
                                                    ];

                                                    // Find first active feature by priority
                                                    const activeFeature = priority.find((feature) =>
                                                        data.find((f) => f.id === feature.id && f.on)
                                                    );

                                                    return activeFeature ? activeFeature.label : "-";
                                                })()}
                                            </div>

                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
                <div className='device-select-btn-main'>
                    <div className='device-select-btn-container'>
                        <div
                            className={`device-btn ${props?.bedDetails?.Noccarc_patientMonitorId ? props.config.activeDevice === DEVICE_TYPES.NOCCARC_PM_NX5 ? "active-device-component" : "" : "disabled"}`}
                            onClick={() => { props?.bedDetails?.Noccarc_patientMonitorId ? props.activeDeviceAction(DEVICE_TYPES.NOCCARC_PM_NX5) : console.log('Device not configered') }}
                        >
                            Patient Monitor
                        </div>
                        <div
                            className={`device-btn ${props?.bedDetails?.ventilatorId ? props.config.activeDevice === DEVICE_TYPES.VENTILATOR ? "active-device-component" : "" : "disabled"}`}
                            onClick={() => { props?.bedDetails?.ventilatorId ? props.activeDeviceAction(DEVICE_TYPES.VENTILATOR) : console.log('Device not configered') }}
                        >
                            Ventilator
                        </div>
                    </div>
                    <img src={crossSvg} className="cross-container" alt="close" onClick={props.handleCrossClick} />
                </div>
            </div>
            <div className="active-subheader-body-container">

                <div className="active-subheader-body-container-sidebar">
                    <div className="sidebar-icons">
                        <div
                            className={
                                activeSubHeader === BED_DETAILS_MODULE.PATIENT_DETAILS
                                    ? "icon-wrapper-active"
                                    : "icon-wrapper"
                            }
                            onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.PATIENT_DETAILS)}
                        >
                            <img src={patientDetails} alt="PD" />
                        </div>

                        <div
                            className={
                                activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS
                                    ? "icon-wrapper-active"
                                    : "icon-wrapper"
                            }
                            onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.VITAL_DETAILS)}
                        >
                            <img src={vitalGraphs} alt="VG" />
                        </div>
                        

                        {/* <div
                            className={
                                activeSubHeader === BED_DETAILS_MODULE.REPORT
                                    ? "icon-wrapper-active"
                                    : "icon-wrapper"
                            }
                            onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.REPORT)}
                        >
                            <img src={vitalReport} alt="VR" />
                        </div> */}

                        <div
                            className={
                                activeSubHeader === BED_DETAILS_MODULE.ALARMS
                                    ? "icon-wrapper-active"
                                    : "icon-wrapper"
                            }
                            onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.ALARMS)}
                        >
                            <img src={eventHistory} alt="EH" />
                        </div>
                        <div
                            className={
                                activeSubHeader === BED_DETAILS_MODULE.TRENDS_REPORTS
                                    ? "icon-wrapper-active"
                                    : "icon-wrapper"
                            }
                            onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.TRENDS_REPORTS)}
                        >
                            <img src={vitalTrends} alt="VT" />
                        </div>
                        {props.config.activeDevice === DEVICE_TYPES.VENTILATOR &&
                            <div
                                className={
                                    activeSubHeader === BED_DETAILS_MODULE.PRE_USE_HISTORY
                                        ? "icon-wrapper-active"
                                        : "icon-wrapper"
                                }
                                onClick={() => handleSubHeaderClick(BED_DETAILS_MODULE.PRE_USE_HISTORY)}
                            >
                                <img src={preUseHistory} alt="PUH" />
                            </div>
                        }
                    </div>
                </div>
                <div className="active-subheader-body-container-main">
                    {activeSubHeader === BED_DETAILS_MODULE.PATIENT_DETAILS &&
                        <PatientDetails
                            bedId={bedId}
                        />
                    }
                    {activeSubHeader === BED_DETAILS_MODULE.VITAL_DETAILS &&
                        <VitalDetailsContainer
                            bedId={bedId}
                            monitorEcgWaveFormData={props.monitorEcgWaveFormData}
                            monitorRespWaveFormData={props.monitorRespWaveFormData}
                            monitorPlethWaveFormData={props.monitorPlethWaveFormData}
                            monitorHeartBeatData={props.monitorHeartBeatData}
                            vitalData_ECG={props.monitorData_ECG && props.monitorData_ECG.vitals}
                            vitalData_SPO2={props.monitorData_SPO2 && props.monitorData_SPO2.vitals}
                            vitalData_NIBP={props.monitorData_NIBP && props.monitorData_NIBP.vitals}
                            vitalData_TEMP={props.monitorData_TEMP && props.monitorData_TEMP.vitals}
                            ventilatorModesData={props.ventilatorModesData}
                            alarmData={props.alarmData}
                            activeVitalDevice={props.config.activeDevice}
                            handleSeeAllAlarms={() => handleSubHeaderClick(BED_DETAILS_MODULE.ALARMS)}
                        />
                    }
                    {activeSubHeader === BED_DETAILS_MODULE.REPORT &&
                        <ReportContainer
                            bedId={bedId}
                            monitorHeartBeatData={props.monitorHeartBeatData}

                        />
                    }
                    {activeSubHeader === BED_DETAILS_MODULE.TRENDS_REPORTS && (
                        props.config.activeDevice === DEVICE_TYPES["NOCCARC_PM_NX5"] ? (
                            <PatientHistory
                                bedId={bedId}
                            />
                        ) : (
                            <V730iPatientHistory
                                bedId={bedId}
                            />
                        )
                    )}
                    {activeSubHeader === BED_DETAILS_MODULE.ALARMS &&
                        <AlarmHistoryContainer
                            bedId={bedId}
                            ventilatorModesData={props.ventilatorModesData}
                            ventilatorAlarmData={props.ventilatorAlarmData}
                            alarmData={props.alarmData}
                            activeVitalDevice={props.config.activeDevice}
                            userView={props.config.userView}

                        />
                    }
                    {activeSubHeader === BED_DETAILS_MODULE.PRE_USE_HISTORY &&
                        <PreUseHistory bedId={bedId} />
                    }
                </div>
            </div>
        </div>
    );
}

export default PatientRightPanelDesktopView;
